import { MapPin, Instagram, Utensils } from "lucide-react";
import { ABOUT_IMAGE, COPY } from "@/lib/site";
import { Reveal } from "./Motion";
import { Img } from "./Img";

const chipIcons = [MapPin, Instagram, Utensils];

export const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="grain py-24 md:py-36"
    >
      <div className="container-editorial">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <Reveal className="lg:col-span-5 order-2 lg:order-1">
            <div className="relative">
              <div className="overflow-hidden rounded-sm aspect-[4/5]">
                <Img
                  name={ABOUT_IMAGE}
                  alt="Editorial portrait of Sona at a warmly lit cafe in Odisha"
                  position="center 20%"
                  imgClassName="w-full h-full transition-transform [transition-duration:1400ms] ease-out hover:scale-105"
                />
              </div>
              <div className="absolute -bottom-4 -right-4 hidden sm:block bg-cream border border-line rounded-sm px-6 py-4">
                <span className="font-display text-3xl leading-none">{COPY.about.badgeName}</span>
                <span className="block kicker mt-1">{COPY.about.badgeRole}</span>
              </div>
            </div>
          </Reveal>

          <div className="lg:col-span-7 order-1 lg:order-2">
            <Reveal>
              <p className="kicker mb-6">{COPY.about.kicker}</p>
              <h2 className="font-display text-4xl sm:text-5xl lg:text-[3.75rem] leading-[1.02] tracking-tight max-w-xl">
                {COPY.about.heading}
              </h2>
            </Reveal>

            <Reveal delay={0.1}>
              <p className="mt-8 max-w-xl text-base md:text-lg font-light leading-relaxed text-ink/75">
                {COPY.about.body}
              </p>
            </Reveal>

            <Reveal delay={0.18}>
              <div className="mt-10 flex flex-wrap gap-3">
                {COPY.about.chips.map((label, i) => {
                  const Icon = chipIcons[i] || MapPin;
                  return (
                    <span
                      key={label}
                      className="inline-flex items-center gap-2 border border-line rounded-full px-5 py-2.5 text-[12px] font-medium tracking-[0.04em] text-ink/80"
                    >
                      <Icon size={15} strokeWidth={1.6} />
                      {label}
                    </span>
                  );
                })}
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};
